import {confetti} from "../framework/utils/confetti-animation";

class GuidanceUtils{
    getEnrollmentDueDate(planYearStartDate){
        let dueDate;
        let month = moment(planYearStartDate).month();
        let date = moment(planYearStartDate).date();
        let year = moment(planYearStartDate).year();

        if(month == 0 && date == 1 ) {
            let enrollmentYear = year - 1;
            dueDate = moment(`11/30/${enrollmentYear}`).format('MMMM Do, YYYY');
        }
        else {
            dueDate = moment(planYearStartDate).subtract(1, 'month').date(15).format('MMMM Do, YYYY');
        }

        return dueDate;
    }

    async showPaDoneConfetti(guidanceItem, isFlex) {
      var confettiFlag = localStorage.getItem('pa_done_confetti' + guidanceItem.employerId);
      if(confettiFlag === 'true') return;

      if(isFlex)
      {
        var enrollmentMethod = await romeApi.get(`/employer/${guidanceItem.employerId}/enrollment-type`);
        if (this.isEdi(enrollmentMethod)) return;
      }

      confetti.show(document.getElementById("confetti-canvas"));
      localStorage.setItem('pa_done_confetti' + guidanceItem.employerId, 'true');
    }

    async takeSurvey(guidanceItem) {
      return await romeApi.get(`employer/${guidanceItem.employerId}/actionItemId/${guidanceItem.actionItemId}/show-take-survey`);
    }

  async getImplemnetationSurveyLink(employerId, workflowId)
  {
    return await romeApi.get(`employer/${employerId}/workflow/${workflowId}/surveyUrl`);
  }

  isEdi(enrollmentMethod) {
    return enrollmentMethod.enrollmentType == 3;
  }

}

const guidanceUtils = new GuidanceUtils()

export { guidanceUtils };



// WEBPACK FOOTER //
// ./src/guidance/guidance-utils.js